export const ADD_MANUAL_OVERTIME = 'ADD_MANUAL_OVERTIME'
export const ADD_MANUAL_OVERTIME_PENDING = 'ADD_MANUAL_OVERTIME_PENDING'
export const ADD_MANUAL_OVERTIME_FULFILLED = 'ADD_MANUAL_OVERTIME_FULFILLED'
export const ADD_MANUAL_OVERTIME_REJECTED = 'ADD_MANUAL_OVERTIME_REJECTED'
